/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Credits_Valid_DaysInputs */

const en_admin_settings_fields_initial_credits_valid_days = /** @type {(inputs: Admin_Settings_Fields_Initial_Credits_Valid_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid days`)
};

/**
* | output |
* | --- |
* | "Valid days" |
*
* @param {Admin_Settings_Fields_Initial_Credits_Valid_DaysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_credits_valid_days = /** @type {((inputs?: Admin_Settings_Fields_Initial_Credits_Valid_DaysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Credits_Valid_DaysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_initial_credits_valid_days(inputs)
});
export { admin_settings_fields_initial_credits_valid_days as "admin.settings.fields.initial_credits_valid_days" }